module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": _vm.src,
      "width": "200"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(_vm.value) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-245ec478"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/Image.vue
// module id = 526
// module chunks = 1